export default __webpack_public_path__ + "assets/images/vector.31d03d.webp";